import i18n from "@/plugins/i18n";

export interface Errors {
  [name: string]: string[];
}

// Функция-костыль - убирает аттрибуты с повторяющимися сообщениями из объекта errors
// TODO: нужно подумать, как доработать/переработать VeeValidate в компонентах чтобы отсюда убрать это.
export function cutErrors(errors: Errors): Errors {
  let newErrors: Errors = {};
  const errorKeys: string[] = Object.keys(errors);
  errorKeys.forEach((key: string) => {
    if (!isMessageAlreadyThere(newErrors, errors[key][0])) {
      newErrors[key] = errors[key];
    }
  });
  return newErrors;
}

// Функция проверки, что в объекте errors уже есть ошибка с текстом errorText
export function isMessageAlreadyThere(
  errors: Errors,
  errorText: string | undefined
): boolean {
  let result: boolean = false;
  const errorKeys: string[] = Object.keys(errors);
  if (errorText !== undefined) {
    errorKeys.forEach((key: string) => {
      result = result || errors[key].includes(errorText);
    });
  }
  return result;
}

// Функция для вывода согласованного падежа слов
export function declOfWords(n: number, type: string): string {
  let text_list = [
    i18n.tc(`${type}.1`),
    i18n.tc(`${type}.2`),
    i18n.tc(`${type}.3`),
  ];
  n = Math.abs(n) % 100;
  let n1 = n % 10;
  if (n > 10 && n < 20) {
    return text_list[2];
  }
  if (n1 > 1 && n1 < 5) {
    return text_list[1];
  }
  if (n1 == 1) {
    return text_list[0];
  }
  return text_list[2];
}

// Функция для вывода согласованного падежа слов
export function declOfForPasswordLength(n: number): string {
  let text_list = [i18n.tc("symbols.2"), i18n.tc("symbols.3")];
  let n1 = n % 10;
  if (n1 == 1 && n != 11) {
    return text_list[0];
  } else {
    return text_list[1];
  }
}

// Функция для вывода переведенных параметров
export function getTranslatedParams(filter: any, filterKeys?: any): object{
  let result:any = {};
  let param:string;
  for (let key of Object.keys(filter)) {
    if (!filter[key]) continue;
    if (!!filterKeys && filterKeys[key]){
      param = filterKeys[key];
    } else {
      param = key;
    }
    result[`${i18n.t(param,'ru')} / ${i18n.t(param,'en')}`] = filter[key];
  }
  return result;
}
